export default {
    MaxFileUpload: 5452595,
    MaxAllFileUpload: 10695475,
    PopupTourguide: 'Tourguide',
    PopupNPS: 'NetPromoterScore',
    PopupAssistant: 'AssistantAva',
    PopupFeature: 'VersionFeature'
}